<template>
	<v-card>
		<v-card-title>出库</v-card-title>

		<v-card-text>
			<div class="d-flex flex-row align-center">
				<bean-selector @selected="onBeanSelected">选择豆</bean-selector>
				<v-radio-group v-model="form.bean_type" inline>
					<v-radio
						v-for="item in refs['BeanType']"
						:error-messages="errors.bean_type"
						:label="item.title"
						:value="item.value"
					></v-radio>
				</v-radio-group>
				<v-alert type="error" v-if="!form.bean_id && errors.bean_id">{{ errors.bean_id }}</v-alert>
			</div>

			<div class="d-flex flex-row align-center">
				<template v-if="selectedBean">
					{{ selectedBean.name }}({{ selectedBean.id }})
					<v-text-field
						type="number"
						v-model.number="form.totalqty"
						:error-messages="errors.totalqty"
						style="max-width: 10rem"
					></v-text-field>
					克 /
					<span class="ml-2" v-if="form.type == 'roasted'" style="color: brown; font-weight: bolder">
						{{ selectedBean.roastedstock }}克 ({{ selectedBean.cprice }}元/千克)
					</span>
					<span class="ml-2" v-if="form.type == 'green'" style="color: green">
						{{ selectedBean.rawstock }}克 ({{ selectedBean.purchaseprice }}元/千克)
					</span>
				</template>
			</div>
			<div class="d-flex flex-row align-center">
				<template v-if="selectableBatches && selectableBatches.length > 0">
					<v-select
						v-model="form.beanbatch_id"
						:items="selectableBatches"
						:item-title="(item) => `${item.date} ${item.bean_type} ${item.type} - ${item.currentqty}g`"
						item-value="id"
						label="选择批次"
					></v-select>
				</template>
				<template v-if="selectedBatch">{{ selectedBatch.currentqty }} 克</template>
			</div>
			<div class="d-flex flex-row align-center">
				<v-text-field
					type="number"
					label="总价值"
					persistent-hint
					hint=""
					v-model.number="form.totalprice"
					:error-messages="errors.totalprice"
					style="max-width: 10rem"
				></v-text-field>
				元
				<v-alert type="info" border="start" variant="tonal">
					这里的总价值只是根据生豆采购价或熟豆的零售价计算
				</v-alert>
			</div>
			<div class="d-flex flex-row align-center">
				类型
				<v-radio-group v-model="form.type" inline>
					<v-radio
						v-for="item in refs['StockLogOutType']"
						:error-messages="errors.type"
						:label="item.title"
						:value="item.value"
					></v-radio>
				</v-radio-group>
			</div>
			<div class="d-flex flex-row align-center">
				<v-textarea
					variant="outlined"
					rows="2"
					type="text"
					label="备注"
					v-model="form.memo"
					:error-messages="errors.memo"
				></v-textarea>
			</div>
		</v-card-text>
		<v-card-actions>
			<slot name="actions" :object="form"></slot>
		</v-card-actions>
	</v-card>
</template>

<script>
import DatePicker from '../common/DatePicker.vue'
import BeanSelector from './Selector.vue'
import { clone } from 'lodash-es'

//这个表单似乎应该做成通用的，支持入库和出库（但是入库只使用批次，所以这里只处理出库）
export default {
	components: {
		BeanSelector,
		DatePicker
	},
	props: {
		mode: { type: String },
		type: { type: Object, default: null }, //预先指定类型，如损耗
		value: { type: Object, default: null },
		errors: { type: Object, default: () => ({}) }
	},
	mounted() {
		this.$api.common.meta('bean', 'BeanType,BeanStatus,StockLogOutType', (res) => {
			this.refs = res
		})
		if (this.value) {
			this.form = clone(this.value)
			if (this.form.bean_id) this.loadBean(this.form.bean_id)
		}
	},
	watch: {
		// 'form.bean_id'(v) {
		// 	if (v) {
		// 		this.loadBean(v)
		// 	}
		// },
		'form.bean_type'(v) {
			this.calcTotalPrice()
			this.loadBatches()
		},
		'form.totalqty'(v) {
			this.calcTotalPrice()
		},
		value(v) {
			if (v) this.form = clone(v)
		}
	},
	data() {
		return {
			form: {
				date: null,
				bean_id: null,
				beanbatch_id: null,
				type: null,
				totalqty: 0,
				totalprice: 0
			},
			menu: false,
			selectedBean: {},
			refs: {},
			selectableBatches: [],
			selectedBatchQty: 0
		}
	},
	computed: {
		selectedBatch() {
			return this.selectableBatches.find((e) => e.id == this.form.beanbatch_id)
		}
	},
	methods: {
		loadBean(id) {
			this.$api.bean.getById(id, (res) => {
				this.selectedBean = res
				this.form.bean_id = id
				this.calcTotalPrice()
				this.loadBatches()
			})
		},
		loadBatches() {
			if (!this.form.bean_id) return
			this.form.beanbatch_id = null
			let params = {
				bean_id: this.form.bean_id,
				currentQty: ' > 0'
			}
			if (this.form.bean_type) params['bean_type'] = this.form.bean_type
			params['pagesize'] = 100
			this.$api.bean.searchBatch(params, (res) => {
				if (res.total > 0) {
					this.selectableBatches = res.objects
				} else {
					alert('没有可用的批次，请先添加批次')
				}
			})
		},
		onBeanSelected(beanids, beans) {
			this.form.bean_id = beanids[0]
			this.selectedBean = beans[0]
			this.selectableBatches = []
			this.loadBatches()
		},
		calcTotalPrice() {
			if (!this.form.totalqty || !this.form.bean_type || !this.selectedBean) return
			if (this.form.bean_type === 'roasted') {
				this.form.totalprice = (this.form.totalqty * this.selectedBean.cprice) / 1000
			} else if (this.form.bean_type === 'green') {
				this.form.totalprice = (this.form.totalqty * this.selectedBean.purchaseprice) / 1000
			}
		}
	}
}
</script>
